import { Configuration, IConfiguration } from './domain/conf'
import { Page } from './domain/page'
import { AdService } from './services/ads'
import { WithAmazonBidding } from './services/ads/adapters/amazon'
import { WithDistrictMBidding } from './services/ads/adapters/district-m'
import { GPTAdapter } from './services/ads/adapters/google-publisher-tag/gpt'
import { WithIndexExchangeBidding } from './services/ads/adapters/index-exchange'
import { WithIntegralAdScience } from './services/ads/adapters/integral-ad-science'
import { defaultAdURIFormatter } from './services/ads/formatters/default'
import { DefaultAdTargetingStrategy } from './services/ads/targeting/default'
import { AdTargetLookup } from './services/ads/targeting/lookup'
import { AnalyticsService } from './services/analytics'
import { MParticle } from './services/analytics/adapters/mparticle'
import { DefaultAnalyticsFormatter } from './services/analytics/formatters/default'
import { IdentityService } from './services/identity'
import { JanrainAdapter } from './services/identity/adapters/janrain'
import { WithPiano } from './services/identity/adapters/piano'
import { GlobalStore } from './utils/storage/global'
import { Store } from './utils/storage/keys'

export const initPage = (conf: IConfiguration) =>
    new Page(
        new Configuration(conf),
        new AdService(
            new (WithIndexExchangeBidding(
                WithIntegralAdScience(
                    WithDistrictMBidding(
                        WithAmazonBidding(GPTAdapter)))))(),
            defaultAdURIFormatter,
            new DefaultAdTargetingStrategy(AdTargetLookup)),
        new AnalyticsService(
            new MParticle(),
            new DefaultAnalyticsFormatter()),
        new IdentityService(
            new (WithPiano(JanrainAdapter))()))

export { GlobalStore, Store }
